// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { purchasedProductCardStyles } from "@eisinc/Overrides/Components/PurchasedProductCard";
import { sharedProductDescriptionStyles, xScreen } from "@eisinc/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


purchasedProductCardStyles.addToCartWrapper = {
    css: css`
        display: flex;
        column-gap: 8px;
    `,
};

purchasedProductCardStyles.addToListWrapper = {
    css: css``,
};
purchasedProductCardStyles.mainWrapper = {
    css: css`
        padding: 10px;
        border-bottom: 1px solid ${getColor("common.border")};
        display: grid;
        grid-template-columns: 85px minmax(280px, 1fr) minmax(0, 162px) minmax(0, 140px) 162px;
        gap: 8px 16px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 85px minmax(280px, 1fr)  minmax(0,162px);
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: 85px 1fr;
        }
    `,
};

purchasedProductCardStyles.imageStyledWrapper = {
    css: css`
        grid-column: 1/2;
    `,
};
purchasedProductCardStyles.infoContainer = {
    css: css`
        grid-column: 2/3;
    `,
};
purchasedProductCardStyles.priceGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        justify-content: flex-start;
        ${xScreen("lte", "md")} {
            grid-column: 2/3;
            grid-row: 2/3;
        }      
    `,
};

purchasedProductCardStyles.availabilityGridItem = {
    width: 12,
    css: css`
    ${xScreen("lte", "md")} {
        grid-row: 3/4;
        grid-column: 2/3;
    }
    `,
};

purchasedProductCardStyles.actionsGridItem = {
    width: 2,
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        grid-column: 5/6;
        align-items: flex-end;

        ${xScreen("lte", "md")} {
            grid-column: 3/4;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 2/3;
            grid-row: 4/5;
            align-items: flex-start;
        }
    `,
};

purchasedProductCardStyles.quantityBreakPricing = {
    viewLink: {
        typographyProps: { size: 12 },
    },
};
purchasedProductCardStyles.descriptionStyles = {
    ...sharedProductDescriptionStyles(),
};
purchasedProductCardStyles.addToListLink = {};

purchasedProductCardStyles.partNumbersStyles = {
};

purchasedProductCardStyles.priceStyles = {

};
purchasedProductCardStyles.addToCartButton = {

};
